//import { useErrorBoundary } from "react-error-boundary";


const ErrorFallback = ({ error }: any) => {

  //const { resetBoundary } = useErrorBoundary();

  return (
    <div className="error-container">
      <h1>Votre session a expiré</h1>
      <p hidden>{error?.message}</p>
      <p>Veuillez vous reconnecter</p>
      <a type="button" href="https://loc-hall.fr/">Se connecter</a>
    </div>
  );
};

export default ErrorFallback;
